// Only the tracker-issued ephemeral token belongs in payment attribution.
export function validGizmoSession(value: unknown): string | undefined {
  return typeof value === "string" && /^[a-f0-9]{16,64}$/.test(value) ? value : undefined;
}

export function getGizmoSession(): string | undefined {
  try {
    if (typeof window === "undefined" || typeof window.gizmo?.session !== "function") return undefined;
    return validGizmoSession(window.gizmo.session());
  } catch {
    // Analytics must never prevent a customer from opening checkout.
    return undefined;
  }
}

export function gizmoSessionMetadata(value: unknown): { gizmo_session?: string } {
  const session = validGizmoSession(value);
  return session ? { gizmo_session: session } : {};
}
